import React from 'react';
import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './Household.css';

export const Household = () => {
    const layout = [
        { i: 'panel1', x: 0, y: 0, w: 6, h: 6, static: false },
        { i: 'panel2', x: 6, y: 0, w: 6, h: 6, static: false },
        { i: 'panel3', x: 0, y: 6, w: 6, h: 6, static: false },
        { i: 'panel4', x: 6, y: 6, w: 6, h: 6, static: false }
    ];

    return (
        <div className="household-container">
            <h1>Household Pantry</h1>
            <GridLayout
                className="layout"
                layout={layout}
                cols={12}
                rowHeight={100}
                width={1200}
                isDraggable={true}
                isResizable={false}
                margin={[20, 20]}
                compactType="vertical"
                preventCollision={false}
                useCSSTransforms={true}
            >
                <div key="panel1" className="panel">
                    <h3>Panel 1</h3>
                    {/* Add your content here */}
                </div>
                <div key="panel2" className="panel">
                    <h3>Panel 2</h3>
                    {/* Add your content here */}
                </div>
                <div key="panel3" className="panel">
                    <h3>Panel 3</h3>
                    {/* Add your content here */}
                </div>
                <div key="panel4" className="panel">
                    <h3>Panel 4</h3>
                    {/* Add your content here */}
                </div>
            </GridLayout>
        </div>
    );
};

